import React, { useState, useEffect } from "react";
import axios from "axios";
import "./RedeemRewardsModal.css";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import { useTranslation } from "react-i18next";
import { Endpoints } from "../../Global/Endpoints";
// import { useTranslation } from 'react-i18next';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ErrorModal from "../Security/ErrorModal";

Modal.setAppElement("#root");
// const { t, i18n } = useTranslation();

const RedeemRewardsModal = ({ 
  isOpen, 
  onClose, 
  email, 
  setEmail, 
  amount, 
  setAmount, 
  reloadHistory 
}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const token = localStorage.getItem("AccessToken") || "YOUR_ACCESS_TOKEN_HERE";
  const deviceType = "PatientPortal";
  const contract = useSelector((state) => state.userData);
  const { t } = useTranslation();
  const [localAmount, setLocalAmount] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  useEffect(() => {
    if (!isOpen) {
      setError(null); // Clear errors when modal is closed
      //setAmount(""); // Clear the amount field when the modal is closed
      setLocalAmount(0);
    }
  }, [isOpen, setAmount]);
  
  const handleRedeem = async () => {
    if (!localAmount && localAmount !== 0) {
      toast.error(t("Please enter a redemption amount!"));
      return;
    }
  
    if (localAmount < 10) {
      toast.error(t("Enter a redemption amount greater than $10!"));
      return;
    }
    if (localAmount > amount) {
      setShowModal(true);
      setModalMessage(
        <>
          <b>{t("Whoops! You haven't earned quite enough - yet.")}</b>
          <br />
          <p>{t(
            "You will need to earn atleast $10 in WINReward before you can redeem. Keep tracking your goals and you will be there soon. You've got this!"
          )}</p>
        </>
      );
      return;
    }
    // Validate email and amount
    if (!contract.userData.EmailID || !localAmount || localAmount <= 0) {
      toast.error(t("Enter a valid amount and email!"));
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const params = {
        emailId: email,
        MemberID: contract.userData.MemberID,
        Contract: contract.userData.ContractIdentified,
        DeviceType: deviceType,
        EmailID: contract.userData.EmailID,
        redemptionAmount: `-${localAmount}`, // Negative value for redemption
      };

      const response = await axios.post(
        Endpoints.SaveRewardRedemptionDetails,
        `_Params=${encodeURIComponent(JSON.stringify(params))}`,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data?.result === 1) {
        console.log(response.data.resultText); // Log success message
        setModalMessage("It can take up to 24 hours to receive your WINRewards card, so keep an eye on your inbox – and your spam folder.");
        setShowModal(true);
        // onClose(); // Don't close immediately, wait for OK
        // reloadHistory(); // Don't reload immediately, wait for OK
      } else {
        setError(t('failedtosaverewards'));
      }
    } catch (err) {
      setError(t('errortosaverewards'));
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;


  const resetFields = () => {
    
  };

  const handleCancel = () => {
    resetFields();
    onClose();
  };

  return (
    <>
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="Vitals Entry"
      className="tracker-modal-content"
      overlayClassName="tracker-modal-overlay"
      shouldCloseOnOverlayClick={false}
    >
      <h2>{t('heading1')}</h2>
      <h6 style={{textAlign:'center'}}>{t('heading2')}</h6>

      <p>&nbsp;</p>

      <div className="modell-form-wrapper">
        <div className="mb-4 row align-items-center align-center">
          <label htmlFor="email" className="col-sm-4 model-form-label">{t('emailid')}</label>
          <div className="col-sm-8">
            <input
                type="email"
                id="email"
                value={email} // Auto-populate the email
                onChange={(e) => setEmail(e.target.value)}
                placeholder={t('emailvalid')}
                className="form-control win-form-control-re mobile-view"
                required
              />            
          </div>
        </div>

        <div className="mb-4 row align-items-center">
          <label htmlFor="email" className="col-sm-4 model-form-label">{t('redemtion')}</label>
          <div className="col-sm-8 redem-rewards">
          <input
          type="number"
         // value={localAmount || ""}
          onChange={(e) => setLocalAmount(Number(e.target.value))}
          placeholder="Redemption Amount ($0.00)"
          min="0"
          max={amount} // Restrict max to available amount
          className="form-control win-form-control-re mobile-view "
        />
          </div>
        </div>

        <div className="mb-4 row align-items-center">
          <label className="col-sm-4 model-form-label"></label>
          <div className="mb-4 button-group-wrapper" >
            <button
              className="win-btn-secondary model-popup-btn me-3 mb-3 mb-sm-0"
              onClick={handleCancel}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="win-btn-primary-wi-content model-popup-btn me-3 mb-3 mb-sm-0 "
              onClick={handleRedeem}
              disabled={loading}              
            >
              {loading ? "Processing..." : "Redeem WINReward Card"}
            </button>
          </div>
        </div>
      </div>
    </Modal>
   { showModal && <ErrorModal
        isOkay={true}
        show={showModal}
        message={modalMessage}
        onOkay={() => {
          setShowModal(false);
          onClose();
          reloadHistory();
        }}
    />}
    </>
  );
};

export default RedeemRewardsModal;
